import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { NewBookingAvailabilityPage } from './new-booking-availability.page';

const routes: Routes = [
  {
    path: '',
    component: NewBookingAvailabilityPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [NewBookingAvailabilityPage]
})
export class NewBookingAvailabilityPageModule {}
